module.exports = __webpack_public_path__ + "img/萨克斯.png";